export const overrideOwnerRequiredMessage = "Override owner is required.";
export const overrideRationaleRequiredMessage = "Override rationale is required.";
